export default "__VITE_ASSET__CtJeloNX__"